"use client";

import AdminSidebar from "../../components/AdminSidebar";
import Link from "next/link";
import { useEffect, useState } from "react";

const empty = {
  id: null,
  nombre: "", slug: "", ciudad: "", estado: "", zipCode: "",
  direccion: "", telefono: "", email: "", website: "",
  contactNombre: "", contactTelefono: "", contactEmail: "",
  descripcionRutas: "", numeroUnidades: "", tipoVehiculos: "",
  bankName: "", bankAccount: "", bankRouting: "", bankType: "checking", stripeAccount: "",
  plan: "Starter", comision: "", status: "Activo", notas: "",
};

export default function EmpresasPage() {
  const [empresas, setEmpresas] = useState<any[]>([]);
  const [form, setForm] = useState<any>(empty);
  const [mostrarForm, setMostrarForm] = useState(false);
  const [msg, setMsg] = useState("");
  const [msgColor, setMsgColor] = useState("#f5a623");
  const [tab, setTab] = useState("info");
  const [buscar, setBuscar] = useState("");
  const [guardando, setGuardando] = useState(false);

  async function cargar() {
    try {
      const res = await fetch("/api/empresas", { cache: "no-store" });
      setEmpresas(await res.json());
    } catch { setEmpresas([]); }
  }

  useEffect(() => { cargar(); }, []);

  function upd(field: string, value: string) {
    if (field === "nombre") {
      const slug = value.toLowerCase().replace(/\s+/g, '-').replace(/[^a-z0-9-]/g, '');
      setForm((f: any) => ({ ...f, nombre: value, slug }));
    } else {
      setForm((f: any) => ({ ...f, [field]: value }));
    }
  }

  function nueva() {
    setForm(empty);
    setTab("info");
    setMsg("");
    setMostrarForm(true);
  }

  function cancelar() {
    setMostrarForm(false);
    setForm(empty);
    setMsg("");
    setTab("info");
  }

  async function guardar(e: React.FormEvent) {
    e.preventDefault();
    if (!form.nombre) { setMsg("El nombre es requerido"); setMsgColor("#e74c3c"); return; }
    setGuardando(true);
    try {
      const res = await fetch("/api/empresas", {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify(form),
      });
      if (!res.ok) throw new Error("Error guardando");
      setMsg("✓ Empresa guardada correctamente");
      setMsgColor("#2ecc71");
      setMostrarForm(false);
      setForm(empty);
      cargar();
      setTimeout(() => setMsg(""), 3000);
    } catch (err: any) {
      setMsg(err.message);
      setMsgColor("#e74c3c");
    } finally {
      setGuardando(false);
    }
  }

  const tabs = [
    { id:"info",    label:"🏢 Empresa" },
    { id:"contacto",label:"👤 Contacto" },
    { id:"rutas",   label:"🗺️ Rutas" },
    { id:"banco",   label:"🏦 Banco" },
    { id:"plan",    label:"📋 Plan" },
  ];

  const empresasFiltradas = empresas.filter((e: any) =>
    (e.nombre||"").toLowerCase().includes(buscar.toLowerCase())
  );

  return (
    <main style={{minHeight:"100vh",background:"#050b18",color:"#fff",fontFamily:"sans-serif"}}>
      <AdminSidebar />
      <section style={{marginLeft:"260px",padding:"36px"}}>

        {/* Header */}
        <div style={{display:"flex",justifyContent:"space-between",alignItems:"flex-start",marginBottom:"28px"}}>
          <div>
            <h1 style={{fontSize:"28px",margin:0,color:"#f5a623"}}>Empresas de Transporte</h1>
            <p style={{color:"#8ea0c4",marginTop:"6px",fontSize:"14px"}}>
              {empresas.length} empresa{empresas.length!==1?"s":""} registrada{empresas.length!==1?"s":""}
            </p>
          </div>
          {!mostrarForm && (
            <button onClick={nueva}
              style={{background:"#f5a623",color:"#000",border:"none",padding:"12px 24px",borderRadius:"10px",fontWeight:800,cursor:"pointer",fontSize:"14px"}}>
              + Nueva Empresa
            </button>
          )}
        </div>

        {/* FORMULARIO — solo aparece cuando mostrarForm=true */}
        {mostrarForm && (
          <div style={{background:"#0f1d36",border:"2px solid #f5a623",borderRadius:"18px",marginBottom:"32px",overflow:"hidden"}}>

            {/* Header del form */}
            <div style={{background:"#07111f",padding:"18px 28px",display:"flex",justifyContent:"space-between",alignItems:"center",borderBottom:"1px solid #1a2744"}}>
              <span style={{color:"#f5a623",fontWeight:800,fontSize:"16px"}}>
                {form.id ? `Editando: ${form.nombre}` : "Nueva Empresa de Transporte"}
              </span>
              <button onClick={cancelar}
                style={{background:"transparent",border:"1px solid #334",color:"#667",padding:"6px 16px",borderRadius:"8px",cursor:"pointer",fontSize:"13px"}}>
                ✕ Cancelar
              </button>
            </div>

            {/* Tabs navegación */}
            <div style={{display:"flex",background:"#07111f",borderBottom:"1px solid #1a2744"}}>
              {tabs.map(t => (
                <button key={t.id} onClick={() => setTab(t.id)}
                  style={{
                    padding:"13px 22px", border:"none", background:"transparent",
                    color: tab===t.id ? "#f5a623" : "#6677aa",
                    fontWeight: tab===t.id ? 800 : 400,
                    cursor:"pointer", fontSize:"13px",
                    borderBottom: tab===t.id ? "2px solid #f5a623" : "2px solid transparent",
                  }}>
                  {t.label}
                </button>
              ))}
            </div>

            {/* Indicador de progreso */}
            <div style={{display:"flex",gap:"6px",padding:"14px 28px",background:"#07111f",borderBottom:"1px solid #1a2744"}}>
              {tabs.map((t,i) => (
                <div key={t.id} style={{display:"flex",alignItems:"center",gap:"6px"}}>
                  <div style={{
                    width:"22px",height:"22px",borderRadius:"50%",
                    background: tab===t.id ? "#f5a623" : "#1a2744",
                    color: tab===t.id ? "#000" : "#334",
                    display:"flex",alignItems:"center",justifyContent:"center",
                    fontSize:"11px",fontWeight:800,cursor:"pointer",
                  }} onClick={() => setTab(t.id)}>
                    {i+1}
                  </div>
                  {i < tabs.length-1 && <div style={{width:"24px",height:"1px",background:"#1a2744"}} />}
                </div>
              ))}
              <span style={{marginLeft:"12px",fontSize:"12px",color:"#6677aa"}}>
                Paso {tabs.findIndex(t=>t.id===tab)+1} de {tabs.length} — todos los datos se guardan juntos
              </span>
            </div>

            <form onSubmit={guardar} style={{padding:"28px"}}>

              {/* TAB: EMPRESA */}
              {tab==="info" && (
                <div style={{display:"flex",flexDirection:"column",gap:"16px"}}>
                  <div style={g2}>
                    <F label="Nombre de la Empresa *" value={form.nombre} onChange={(v:string)=>upd("nombre",v)} placeholder="Boston Express LLC" />
                    <F label="Slug (URL — auto generado)" value={form.slug} onChange={(v:string)=>upd("slug",v)} placeholder="boston-express-llc" />
                  </div>
                  <div style={g2}>
                    <F label="Ciudad" value={form.ciudad} onChange={(v:string)=>upd("ciudad",v)} placeholder="Boston" />
                    <F label="Estado" value={form.estado} onChange={(v:string)=>upd("estado",v)} placeholder="MA" />
                  </div>
                  <div style={g2}>
                    <F label="Dirección" value={form.direccion} onChange={(v:string)=>upd("direccion",v)} placeholder="123 Main St" />
                    <F label="Código Postal" value={form.zipCode} onChange={(v:string)=>upd("zipCode",v)} placeholder="02101" />
                  </div>
                  <div style={g2}>
                    <F label="Teléfono" value={form.telefono} onChange={(v:string)=>upd("telefono",v)} placeholder="+1 (617) 555-0100" />
                    <F label="Email de la empresa" value={form.email} onChange={(v:string)=>upd("email",v)} placeholder="info@bostonexpress.com" />
                  </div>
                  <F label="Sitio Web" value={form.website} onChange={(v:string)=>upd("website",v)} placeholder="https://bostonexpress.com" />
                  <Nav onNext={() => setTab("contacto")} />
                </div>
              )}

              {/* TAB: CONTACTO */}
              {tab==="contacto" && (
                <div style={{display:"flex",flexDirection:"column",gap:"16px"}}>
                  <Note>Datos del dueño o representante principal de la empresa</Note>
                  <F label="Nombre completo del dueño" value={form.contactNombre} onChange={(v:string)=>upd("contactNombre",v)} placeholder="Juan García" />
                  <div style={g2}>
                    <F label="Teléfono del dueño" value={form.contactTelefono} onChange={(v:string)=>upd("contactTelefono",v)} placeholder="+1 (617) 555-0200" />
                    <F label="Email del dueño" value={form.contactEmail} onChange={(v:string)=>upd("contactEmail",v)} placeholder="juan@bostonexpress.com" />
                  </div>
                  <Nav onPrev={() => setTab("info")} onNext={() => setTab("rutas")} />
                </div>
              )}

              {/* TAB: RUTAS */}
              {tab==="rutas" && (
                <div style={{display:"flex",flexDirection:"column",gap:"16px"}}>
                  <Note>Información operativa — rutas y flota de vehículos</Note>
                  <FA label="Rutas que opera (una por línea)" value={form.descripcionRutas} onChange={(v:string)=>upd("descripcionRutas",v)}
                    placeholder={"Boston → New York\nBoston → Miami\nBoston → Washington DC"} />
                  <div style={g2}>
                    <F label="Número de vehículos / unidades" value={form.numeroUnidades} onChange={(v:string)=>upd("numeroUnidades",v)} placeholder="5" />
                    <F label="Tipo de vehículos" value={form.tipoVehiculos} onChange={(v:string)=>upd("tipoVehiculos",v)} placeholder="Van, Bus, Sprinter" />
                  </div>
                  <Nav onPrev={() => setTab("contacto")} onNext={() => setTab("banco")} />
                </div>
              )}

              {/* TAB: BANCO */}
              {tab==="banco" && (
                <div style={{display:"flex",flexDirection:"column",gap:"16px"}}>
                  <Note>Información bancaria para pagos y desembolsos automáticos</Note>
                  <div style={g2}>
                    <F label="Nombre del banco" value={form.bankName} onChange={(v:string)=>upd("bankName",v)} placeholder="Bank of America" />
                    <S label="Tipo de cuenta" value={form.bankType} onChange={(v:string)=>upd("bankType",v)}
                      opts={[{v:"checking",l:"Checking"},{v:"savings",l:"Savings"}]} />
                  </div>
                  <div style={g2}>
                    <F label="Número de cuenta" value={form.bankAccount} onChange={(v:string)=>upd("bankAccount",v)} placeholder="••••••••••" />
                    <F label="Routing Number" value={form.bankRouting} onChange={(v:string)=>upd("bankRouting",v)} placeholder="021000021" />
                  </div>
                  <F label="Stripe Account ID (si aplica)" value={form.stripeAccount} onChange={(v:string)=>upd("stripeAccount",v)} placeholder="acct_1234567890" />
                  <Nav onPrev={() => setTab("rutas")} onNext={() => setTab("plan")} />
                </div>
              )}

              {/* TAB: PLAN */}
              {tab==="plan" && (
                <div style={{display:"flex",flexDirection:"column",gap:"16px"}}>
                  <Note>Plan de suscripción, comisión y estado de la cuenta</Note>
                  <div style={g2}>
                    <S label="Plan" value={form.plan} onChange={(v:string)=>upd("plan",v)}
                      opts={[{v:"Starter",l:"Starter"},{v:"Business",l:"Business"},{v:"Premium",l:"Premium"},{v:"Platinum",l:"Platinum"}]} />
                    <S label="Estado de la cuenta" value={form.status} onChange={(v:string)=>upd("status",v)}
                      opts={[{v:"Activo",l:"✓ Activo"},{v:"Pendiente",l:"⏳ Pendiente"},{v:"Inactivo",l:"✗ Inactivo"}]} />
                  </div>
                  <F label="Comisión acordada %" value={form.comision} onChange={(v:string)=>upd("comision",v)} placeholder="10" />
                  <FA label="Notas internas (privado)" value={form.notas} onChange={(v:string)=>upd("notas",v)} placeholder="Notas privadas sobre esta empresa..." />

                  {/* BOTÓN GUARDAR — solo en el último tab */}
                  <div style={{marginTop:"8px",paddingTop:"20px",borderTop:"1px solid #1a2744",display:"flex",alignItems:"center",gap:"16px"}}>
                    <button type="button" onClick={() => setTab("banco")}
                      style={{background:"transparent",border:"1px solid #334",color:"#8ea0c4",padding:"12px 20px",borderRadius:"10px",cursor:"pointer",fontSize:"14px"}}>
                      ← Anterior
                    </button>
                    <button type="submit" disabled={guardando}
                      style={{background:"#f5a623",color:"#000",border:"none",padding:"14px 36px",borderRadius:"10px",fontWeight:800,cursor:"pointer",fontSize:"15px",opacity:guardando?0.7:1}}>
                      {guardando ? "Guardando..." : form.id ? "💾 Actualizar Empresa" : "💾 Guardar Empresa Completa"}
                    </button>
                    {msg && <span style={{color:msgColor,fontSize:"14px",fontWeight:600}}>{msg}</span>}
                  </div>
                </div>
              )}

            </form>
          </div>
        )}

        {/* Mensaje fuera del form */}
        {!mostrarForm && msg && (
          <div style={{background:"#0f1d36",border:`1px solid ${msgColor}`,borderRadius:"10px",padding:"12px 20px",marginBottom:"20px",color:msgColor,fontSize:"14px"}}>
            {msg}
          </div>
        )}

        {/* TABLA */}
        <div style={{background:"#0f1d36",border:"1px solid #1a2744",borderRadius:"18px",overflow:"hidden"}}>
          <div style={{padding:"20px 24px",borderBottom:"1px solid #1a2744",display:"flex",justifyContent:"space-between",alignItems:"center"}}>
            <span style={{fontWeight:700,color:"#f5a623",fontSize:"15px"}}>Empresas Registradas</span>
            <input value={buscar} onChange={e=>setBuscar(e.target.value)} placeholder="Buscar empresa..."
              style={{background:"#07111f",border:"1px solid #1a2744",borderRadius:"8px",padding:"8px 14px",color:"#fff",fontSize:"13px",outline:"none",width:"220px"}} />
          </div>
          <table style={{width:"100%",borderCollapse:"collapse"}}>
            <thead>
              <tr style={{background:"#07111f",color:"#f5a623"}}>
                {["Empresa","Ciudad","Estado","Email","Plan","Status","Acción"].map(h=>(
                  <th key={h} style={{padding:"14px 16px",textAlign:"left",fontSize:"12px",fontWeight:800,letterSpacing:"0.05em"}}>{h}</th>
                ))}
              </tr>
            </thead>
            <tbody>
              {empresasFiltradas.length===0 ? (
                <tr><td colSpan={7} style={{padding:"40px",textAlign:"center",color:"#334",fontSize:"14px"}}>
                  No hay empresas registradas — haz clic en <strong style={{color:"#f5a623"}}>+ Nueva Empresa</strong> para comenzar
                </td></tr>
              ) : empresasFiltradas.map((e:any) => (
                <tr key={e.id} style={{borderTop:"1px solid #1a2744"}}>
                  <td style={{padding:"14px 16px",color:"#fff",fontWeight:600,fontSize:"14px"}}>{e.name||e.nombre}</td>
                  <td style={{padding:"14px 16px",color:"#8ea0c4",fontSize:"14px"}}>{e.ciudad||"—"}</td>
                  <td style={{padding:"14px 16px",color:"#8ea0c4",fontSize:"14px"}}>{e.estado||"—"}</td>
                  <td style={{padding:"14px 16px",color:"#8ea0c4",fontSize:"14px"}}>{e.email||"—"}</td>
                  <td style={{padding:"14px 16px"}}>
                    <span style={{background:"#1a3a6a",color:"#7ab",padding:"3px 10px",borderRadius:"6px",fontSize:"12px"}}>{e.plan}</span>
                  </td>
                  <td style={{padding:"14px 16px"}}>
                    <span style={{background:e.active?"#1a3a2a":"#2a1a1a",color:e.active?"#2ecc71":"#e74c3c",padding:"3px 10px",borderRadius:"6px",fontSize:"12px"}}>
                      {e.active?"Activo":"Inactivo"}
                    </span>
                  </td>
                  <td style={{padding:"14px 16px"}}>
                    <button onClick={()=>{ setForm({...empty,...e,nombre:e.name,id:e.id}); setTab("info"); setMostrarForm(true); }}
                      style={{background:"#f5a623",color:"#000",border:"none",padding:"7px 14px",borderRadius:"7px",fontWeight:700,cursor:"pointer",fontSize:"12px"}}>
                      Abrir / Editar
                    </button>
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>

      </section>
    </main>
  );
}

function F({label,value,onChange,placeholder}:any) {
  return (
    <div>
      <label style={{display:"block",fontSize:"11px",color:"#8ea0c4",marginBottom:"5px",letterSpacing:"0.08em",textTransform:"uppercase"}}>{label}</label>
      <input value={value} onChange={e=>onChange(e.target.value)} placeholder={placeholder}
        style={{width:"100%",padding:"11px 14px",borderRadius:"10px",border:"1px solid #24324d",background:"#07111f",color:"#fff",fontSize:"13px",outline:"none",boxSizing:"border-box"}} />
    </div>
  );
}

function FA({label,value,onChange,placeholder}:any) {
  return (
    <div>
      <label style={{display:"block",fontSize:"11px",color:"#8ea0c4",marginBottom:"5px",letterSpacing:"0.08em",textTransform:"uppercase"}}>{label}</label>
      <textarea value={value} onChange={e=>onChange(e.target.value)} placeholder={placeholder} rows={4}
        style={{width:"100%",padding:"11px 14px",borderRadius:"10px",border:"1px solid #24324d",background:"#07111f",color:"#fff",fontSize:"13px",outline:"none",resize:"vertical",fontFamily:"sans-serif",boxSizing:"border-box"}} />
    </div>
  );
}

function S({label,value,onChange,opts}:any) {
  return (
    <div>
      <label style={{display:"block",fontSize:"11px",color:"#8ea0c4",marginBottom:"5px",letterSpacing:"0.08em",textTransform:"uppercase"}}>{label}</label>
      <select value={value} onChange={e=>onChange(e.target.value)}
        style={{width:"100%",padding:"11px 14px",borderRadius:"10px",border:"1px solid #24324d",background:"#07111f",color:"#fff",fontSize:"13px",outline:"none"}}>
        {opts.map((o:any)=><option key={o.v} value={o.v}>{o.l}</option>)}
      </select>
    </div>
  );
}

function Nav({onPrev,onNext}:any) {
  return (
    <div style={{display:"flex",justifyContent:"flex-end",gap:"10px",marginTop:"8px",paddingTop:"16px",borderTop:"1px solid #1a2744"}}>
      {onPrev && <button type="button" onClick={onPrev}
        style={{background:"transparent",border:"1px solid #334",color:"#8ea0c4",padding:"10px 20px",borderRadius:"8px",cursor:"pointer",fontSize:"13px"}}>
        ← Anterior
      </button>}
      {onNext && <button type="button" onClick={onNext}
        style={{background:"#1a3a6a",color:"#7ab",border:"none",padding:"10px 22px",borderRadius:"8px",cursor:"pointer",fontSize:"13px",fontWeight:700}}>
        Siguiente →
      </button>}
    </div>
  );
}

function Note({children}:any) {
  return <p style={{color:"#8ea0c4",fontSize:"13px",margin:0,padding:"10px 14px",background:"#07111f",borderRadius:"8px",borderLeft:"3px solid #f5a623"}}>{children}</p>;
}

const g2={display:"grid",gridTemplateColumns:"1fr 1fr",gap:"16px"};

export const dynamic = "force-dynamic";
